import React from 'react';
import FieldLabelComponents from '@shared/form/field-label/field-label.components';

interface FieldLabelProps {
  text: string;
  isRequired: boolean;
  showLegend?: boolean;
}
const { Container, StyledText, RequiredMark, Legend } = FieldLabelComponents;

const FieldLabel: React.FunctionComponent<FieldLabelProps> = ({
  text,
  isRequired,
  showLegend
}) => {
  return (
    <Container>
      <div>
        <StyledText tParams={text} />
        {isRequired && <RequiredMark>*</RequiredMark>}
      </div>
      {showLegend && <Legend className="ucf-paragraph">*Pflichtfelder</Legend>}
    </Container>
  );
};

export default FieldLabel;
